import { Link } from 'react-router-dom';
import { EstimationGame } from '../components/EstimationGame';

const sanierungsItems = [
  {
    title: 'Komplettsanierung Badezimmer',
    image: 'https://images.unsplash.com/photo-1770838773417-08b18661c62f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxob21lJTIwcmVub3ZhdGlvbiUyMGludGVyaW9yJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3NDI1NjE3Mnww&ixlib=rb-4.1.0&q=85',
    description: 'Kompletter Austausch von Sanitärobjekten, Fliesen, Installationen und Armaturen.',
    details: ['8 m² Badezimmer', 'Neue Sanitärobjekte', 'Neue Fliesen', 'Dusche & Badewanne'],
    question: 'Was kostet diese Badsanierung?',
    actualValue: 18000,
    minValue: 8000,
    maxValue: 35000,
    step: 1000,
    explanation: 'Eine Komplettsanierung kostet typischerweise 1.500-2.500 € pro Quadratmeter. Bei 8 m² und gehobener Ausstattung sind 18.000 € realistisch.'
  },
  {
    title: 'Fassadendämmung Einfamilienhaus',
    image: 'https://images.unsplash.com/photo-1768321903661-87da7d2962b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxob21lJTIwcmVub3ZhdGlvbiUyMGludGVyaW9yJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3NDI1NjE3Mnww&ixlib=rb-4.1.0&q=85',
    description: 'Wärmedämmverbundsystem (WDVS) für ein freistehendes Einfamilienhaus inkl. Gerüst und Putz.',
    details: ['180 m² Fassadenfläche', '16 cm Dämmstärke', 'inkl. Gerüst', 'Neuer Außenputz'],
    question: 'Was kostet diese Fassadendämmung?',
    actualValue: 32000,
    minValue: 15000,
    maxValue: 55000,
    step: 2000,
    explanation: 'Fassadendämmung kostet 150-200 € pro m² inkl. Gerüst und Putz. Bei 180 m² sind 32.000 € ein typischer Wert für Südtirol.'
  },
  {
    title: 'Heizungstausch: Öl auf Wärmepumpe',
    image: 'https://images.pexels.com/photos/5640834/pexels-photo-5640834.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'Austausch einer alten Ölheizung gegen eine Luft-Wasser-Wärmepumpe inkl. Fußbodenheizung im EG.',
    details: ['150 m² Wohnfläche', 'Wärmepumpe 12 kW', 'Neue Fußbodenheizung EG', 'Demontage Öltank'],
    question: 'Was kostet dieser Heizungstausch?',
    actualValue: 42000,
    minValue: 20000,
    maxValue: 70000,
    step: 2000,
    explanation: 'Eine Wärmepumpe inkl. Installation kostet 15.000-25.000 €. Mit Fußbodenheizung und Öltank-Entsorgung steigt der Preis auf ca. 40.000-45.000 €.'
  },
  {
    title: 'Dachsanierung mit Neueindeckung',
    image: 'https://images.unsplash.com/photo-1690633785831-2f4874b578f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob3VzZSUyMG1vdW50YWluJTIwYWxwc3xlbnwwfHx8fDE3NzQyNTYxNzF8MA&ixlib=rb-4.1.0&q=85',
    description: 'Komplette Dachsanierung mit Dämmung, neuer Lattung und Ziegeleindeckung.',
    details: ['140 m² Dachfläche', 'Neue Dämmung 24 cm', 'Neue Ziegel', 'Dachfenster erneuert'],
    question: 'Was kostet diese Dachsanierung?',
    actualValue: 48000,
    minValue: 25000,
    maxValue: 80000,
    step: 2500,
    explanation: 'Eine komplette Dachsanierung kostet 300-400 € pro m². Mit hochwertiger Dämmung und neuen Dachfenstern sind 48.000 € realistisch.'
  }
];

const relatedLinks = [
  { path: '/tippspiele/neubau-oder-sanierung', label: 'Neubau oder Sanierung?' },
  { path: '/ratgeber/hausbau-in-suedtirol', label: 'Hausbau in Südtirol' },
  { path: '/haus-und-bau/baufirma-meran', label: 'Baufirma in Meran finden' }
];

export default function WasKostetEineSanierung() {
  return (
    <div className="section-spacing" data-testid="sanierung-kosten-page">
      <div className="container-wide">
        {/* Breadcrumb */}
        <nav className="text-sm text-[#64748B] mb-8" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-[#0284C7]">Start</Link>
          <span className="mx-2">/</span>
          <Link to="/haus-und-bau" className="hover:text-[#0284C7]">Haus & Bau</Link>
          <span className="mx-2">/</span>
          <span className="text-[#0F172A]">Was kostet eine Sanierung?</span>
        </nav>

        <EstimationGame
          title="Was kostet eine Sanierung?"
          introText="Schätze die Kosten typischer Sanierungsprojekte. So bekommst du ein Gefühl für realistische Budgets – bevor du mit der Planung beginnst."
          items={sanierungsItems}
          unit="€"
          relatedLinks={relatedLinks}
        />

        {/* SEO Content */}
        <div className="mt-16 advisor-content">
          <h2>Sanierungskosten realistisch einschätzen</h2>
          <p>
            Eine der häufigsten Fragen bei Sanierungsprojekten: Was wird das kosten? 
            Die Antwort hängt von vielen Faktoren ab – aber es gibt Richtwerte, die 
            bei der Planung helfen.
          </p>
          
          <h3>Typische Kosten pro Quadratmeter</h3>
          <ul>
            <li><strong>Leichte Sanierung</strong> (Böden, Wände, Elektrik): 400-600 €/m²</li>
            <li><strong>Mittlere Sanierung</strong> (inkl. Bad, Küche): 800-1.200 €/m²</li>
            <li><strong>Kernsanierung</strong> (bis auf Rohbau): 1.500-2.500 €/m²</li>
          </ul>

          <h3>Was beeinflusst die Kosten?</h3>
          <p>
            In Südtirol sind die Handwerkerpreise traditionell etwas höher als im 
            restlichen Italien. Dafür bekommst du in der Regel auch hohe Qualität. 
            Wichtige Kostentreiber sind:
          </p>
          <ul>
            <li>Zustand der Bausubstanz (versteckte Schäden)</li>
            <li>Umfang der energetischen Sanierung</li>
            <li>Ausstattungsqualität (Fliesen, Sanitär, Küche)</li>
            <li>Eigenleistung vs. Vollvergabe</li>
          </ul>

          <p>
            Du planst eine Sanierung in Südtirol? Bei{' '}
            <a href="https://sanieren.it" target="_blank" rel="noopener noreferrer">
              sanieren.it
            </a>{' '}
            findest du Informationen und Kontakte zu erfahrenen Handwerkern in der Region.
          </p>

          <div className="cta-box">
            <div className="cta-box-title">Förderungen nicht vergessen!</div>
            <p className="cta-box-text">
              Für energetische Sanierungen gibt es in Italien und Südtirol attraktive 
              Förderungen. Der Superbonus und andere Programme können einen großen 
              Teil der Kosten abdecken.
            </p>
            <Link to="/ratgeber/hausbau-in-suedtirol" className="text-[#0284C7] font-medium hover:underline">
              Zum Ratgeber: Hausbau in Südtirol →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
